import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterByActive' })
export class TrainingsActivePipe implements PipeTransform {
    transform(trainings: any[], active: boolean): any[] {
        if (!trainings || !active) {
            return trainings;
        }
        let filteredTrainings = [];
        trainings.map((training) => {
            if (training.active === active) {
                filteredTrainings.push(training);
            }
        });
        return filteredTrainings;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/trainings-active.pipe.ts